/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-12 10:01:27
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 20:27:12
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/ProductList/index.tsx
 */
/**
 *  Product List
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import ProductDraggableDisplay from '@/src/constrains/ProductDraggableDisplay/ImgAndSkuShortDisplay';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ProductList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,
    onItemDelete,
    onItemSort,
    onItemDeleteAll,
    onItemReselect,
    products,
    staticData,
    onStaticChange,
    draggableId,
    disabled,
  } = props;

  const { backgroundColor } = staticData || {};

  const handleOnItemReselect = (products) => {
    onItemReselect(products);
  };

  const handleOnItemDelete = (index) => {
    onItemDelete(index);
  };

  const handleOnItemSort = (from, to) => {
    onItemSort(from, to);
  };

  const handleOnItemDeleteAll = () => {
    onItemDeleteAll();
  };

  const handleOnBkgColorChange = (backgroundColor) => {
    if (onStaticChange) {
      onStaticChange({ backgroundColor });
    }
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          title={getI18n('general.backgroundColour')}
          id={`${draggableId}BkgColor`}>
          <ColorPicker
            multi
            color={backgroundColor}
            onChange={handleOnBkgColorChange}
            id={`${draggableId}BkgColor`}
            disable={disabled}
          />
        </ItemWrapper>
      </Section>
      <ProductDraggableDisplay
        droppableId={droppableId || 'testDrop'}
        data={products}
        onChange={handleOnItemReselect}
        onDelete={handleOnItemDelete}
        onSort={handleOnItemSort}
        onDeleteAll={handleOnItemDeleteAll}
        hideTitleRightFunction={(products || []).length == 0}
        disabled={disabled}
      />
    </React.Fragment>
  );
};
export default ProductList;
